// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"DTGVariantList_contentComponent__GDM62","tableContainer":"DTGVariantList_tableContainer__IwXtq"};